<template>
  <section>
    <b-overlay :show="quotesCalendarLoading" spinner-medium>
      <b-card class="app-calendar overflow-hidden">
        <div class="row no-gutters">
          <div class="col position-relative">
            <full-calendar ref="calendarSlot" :options="calendarOptions" :plugins="calendarOptions.plugins" class="full-calendar" />
          </div>
        </div>
      </b-card>
    </b-overlay>
    <OrdersCalendarOrderResume :is-order-resume-sidebar-active.sync="isOrderResumeSidebarActive" :order="orderSelected" @refetch-quote="refreshData" />
  </section>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import { mapActions, mapState } from 'vuex'

import UIHelper from '@/helpers/ui'
import OrdersCalendarOrderResume from '@/views/order/OrdersCalendarOrderResume.vue'
import momentPlugin from '@fullcalendar/moment'

export default {
  name: 'OrdersCalendar',

  components: {
    FullCalendar,
    OrdersCalendarOrderResume,
  },

  mixins: [UIHelper],
  data() {
    return {
      isOrderResumeSidebarActive: false,
      orderSelected: {},
      calendarOptions: {
        plugins: [momentPlugin, dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        initialView: 'timeGridWeek',
        allDaySlot: false,
        headerToolbar: {
          start: 'sidebarToggle, prev,next, title',
          end: 'timeGridWeek,listMonth',
        },
        contentHeight: 500,
        events: [],
        selectable: true,
        eventClick: order => {
          if (this.$can('TRIP_ACCOUNTING_EDIT')) {
            this.orderSelected = order.event
            setTimeout(() => {
              this.isOrderResumeSidebarActive = true
            }, 100)
          }
        },
        datesSet: event => {
          if (new Date(this.currentCalendarRange.start).getTime() !== new Date(event.start).getTime()) {
            this.setCurrentCalendarRange({ start: event.start, end: event.end })
            this.fetchQuotesCalendar()
          }
        },
        eventResizableFromStart: true,
        dragScroll: true,
        navLinks: true,
        eventTimeFormat: {
          // like '14:30:00'
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
          meridiem: false,
        },
        slotLabelFormat: {
          // like '14:30:00'
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
          meridiem: false,
        },
        dayHeaderFormat: 'dd, DD MMM',
        locale: this.$i18n.locale,
        firstDay: 1,
      },
      eventSkeleton: {
        id: null,
        title: '',
        start: null,
        end: null,
        allDay: false,
        color: '#dcc181',
        textColor: '#384D73',
        extendedProps: null,
      },
    }
  },
  computed: {
    ...mapState('quote', ['quotesCalendarLoading', 'quotesCalendar', 'currentCalendarRange', 'dateCalendarSelected']),
  },
  watch: {
    dateCalendarSelected(val) {
      const calendarApi = this.$refs.calendarSlot.getApi()
      calendarApi.gotoDate(val)
    },
    quotesCalendar() {
      this.buildEvent()
    },
  },
  mounted() {
    this.fetchQuotesCalendar()
  },
  methods: {
    ...mapActions('quote', ['fetchQuotesCalendar', 'setCurrentCalendarRange']),
    // Create calendar event for each quote
    buildEvent() {
      this.calendarOptions.events.splice(0)
      this.quotesCalendar.forEach(order => {
        const event = JSON.parse(JSON.stringify(this.eventSkeleton))
        let { state } = order
        if (order.cancelled) { state = 'cancelled' } else if (order.refused) { state = 'refused' } else if (order.cancelledDraft) { state = 'cancelled_draft'}

        event.color = state !== null ? UIHelper.methods.resolveQuoteStateColor(state) : '#384D73'
        event.textColor = state !== null ? UIHelper.methods.resolveQuoteStateTextColor(state) : '#ffffff'
        event.id = order.id
        event.title = `${this.$t('order.order.title')} ${order.reference}`
        // Start
        event.start = this.getDayTime(order.date)
        if (order.endDate) {
          event.end = this.getDayTime(order.endDate)
        }

        event.extendedProps = {
          order,
        }
        this.calendarOptions.events.push(event)
      })
    },
    getDayTime(day) {
      return day ? this.$moment.utc(day).format('YYYY-MM-DD HH:mm:ss') : null
    },
    refreshData() {
      this.fetchQuotesCalendar()
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/apps/calendar.scss';
.fc-daygrid-body.fc-daygrid-body-unbalanced {
  width: 100% !important;
}

.fc-scrollgrid-sync-table {
  width: 100% !important;
}

.fc-col-header {
  width: 100% !important;
}

.fc-selectDateBtn-button {
  margin-left: 2rem !important;
  border-color: #dcc181 !important;
  background-color: #dcc181 !important;
}
div.fc-header-toolbar.fc-toolbar > div:nth-child(1) > div:nth-child(1) > button.fc-sidebarToggle-button.fc-button.fc-button-primary {
  display: none;
}
</style>
